var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedinRed = function SvgLinkedinRed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0C7.164 0 0 7.164 0 16s7.164 16 16 16 16-7.164 16-16S24.836 0 16 0zm-3.703 23.26H8.784V12.723h3.513zM10.54 11.158A1.94 1.94 0 0 1 8.608 9.21a1.94 1.94 0 0 1 1.932-1.95 1.94 1.94 0 0 1 1.932 1.948 1.94 1.94 0 0 1-1.932 1.948zM24.592 23.26h-3.51v-5.026c0-3.304-3.516-3.024-3.516 0v5.026h-3.513V12.72h3.513v1.92c1.532-2.838 7.026-3.049 7.026 2.72z",
    fill: "#c00000"
  })));
};
export default SvgLinkedinRed;